<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-form>
              <b-row>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="admissionRoundId"
                  >
                    <v-select
                      v-model="filter.admissionRoundId"
                      :options="admissionRounds"
                      :reduce="option => option.value"
                      placeholder="Đợt xét tuyển"
                      @input="readAdmissionForm"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="admissionFormId"
                  >
                    <v-select
                      v-model="filter.admissionFormId"
                      :options="dataListAdmissionForm"
                      :reduce="option => option.value"
                      placeholder="Phương thức xét tuyển"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="identification"
                    title="CCCD Thí sinh ứng tuyển"
                  >
                    <b-form-input
                      id="code"
                      v-model="filter.identification"
                      name="name"
                      type="number"
                      placeholder="CCCD Thí sinh ứng tuyển"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <div class="text-right">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="ml-1"
                      @click="onSearchMainData"
                    >
                      <feather-icon icon="FilterIcon" /> Danh sách thí sinh ứng tuyển trong đợt xét tuyển
                    </b-button>
                    <b-button
                      v-if="createPriorityOrder"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="ml-1"
                      @click="onApproveSuspend"
                    >
                      <feather-icon icon="CheckIcon" /> Tính điểm xét tuyển
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <b-row class="mt-0">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-1">
                        <span class="text-nowrap"> Hiển thị {{filter.itemsPerPage * (filter.currentPage-1) +1}}
                          đến {{(filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage)}} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                </div>
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  style-class="vgt-table striped bordered"
                  row-style-class="vgt-row"
                  :columns="columns"
                  :rows="mainData"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span
                      v-if="props.column.field === 'status'"
                      :class="(props.row.status === 1) ? 'text-danger font-weight-bold' : 'text-warning'"
                    >
                      {{ getStatusName(props.row.status) }}
                    </span>
                    <span
                      v-else-if="props.column.field === 'action'"
                      class="thead-group-action"
                    >
                      <b-button-group>
                        <b-button
                          variant="info"
                          class="btn-icon"
                          size="sm"
                        >
                          <feather-icon icon="ListIcon" />
                        </b-button>
                      </b-button-group>
                    </span>
                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>
                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BImg,
  BLink,
  BOverlay,
  BPagination,
  BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import admissionScore from '@/store/admission/admission-score'

export default {
  name: 'AspirationScore',
  directives: {
    Ripple,
  },
  components: {
    BImg, BLink,
    BFormInput,
    BButton,
    BButtonGroup,
    BCard,
    BRow,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    VueGoodTable,
    BFormGroup,
    BForm,
    vSelect,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        admissionRoundId: null,
        admissionFormId: null,
        identification: null,
        sort: null,
      },
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 100],
      currentName: '',
      currentCode: '',
    }
  },
  computed: {
    ...mapGetters({
      mainData: 'admissionScore/dataLists',
      totalRows: 'admissionScore/totalRows',
      resourceName: 'admissionScore/resourceName',
      admissionRounds: 'admissionRound/admissionRoundsByOrganization',
      dataListAdmissionForm: 'admissionForm/admissionFormByAdmissionRoundId',
    }),
    columns() {
      return [
        {
          label: 'CCCD thí sinh',
          field: 'identification',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Họ tên thí sinh ứng tuyển',
          field: 'applicantStudentName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Phương thức xét tuyển',
          field: 'admissionFormName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Ngành xét tuyển',
          field: 'majorName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Thứ tự nguyện vọng',
          field: 'orderNo',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Tổ hợp xét tuyển',
          field: 'blockName',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          label: 'Tổng điểm tổ hợp xét tuyển',
          field: 'sumBlock',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Điểm ưu tiên',
          field: 'priorityScore',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Điểm xét tuyển',
          field: 'admissionScore',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
    createPriorityOrder() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.APPLICANT_STUDENT_PRIORITY_ORDER)
    },
  },
  async created() {
    this.updateParams({ organizationId: this.user.orgId })
    this.isLoading = true
    try {
      await this.getAdmissionRoundsByOrganization({ organizationId: getUser().orgId })
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      getMainData: 'admissionScore/getData',
      createData: 'admissionScore/create',
      readAdmissionFormByAdmissionRoundId: 'admissionForm/readAdmissionFormByAdmissionRoundId',
      getAdmissionRoundsByOrganization: 'admissionRound/readAdmissionRoundsByOrganization',
    }),
    async readAdmissionForm(id) {
      await this.readAdmissionFormByAdmissionRoundId({admissionRoundId: id})
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getMainDataFromStore()
    },
    async getMainDataFromStore() {
      this.isLoading = true
      if ( this.filter.admissionRoundId === null ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Đợt xét tuyển không được để trống!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } else {
        try {
          await this.getMainData(this.filter);
        } catch ( e ) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          });
        } finally {
          this.isLoading = false
        }
      }
      this.isLoading = false
    },
    async onPerPageChange(param) {
      this.updateParams({
        currentPage: param.currentPage,
        itemsPerPage: param.currentPerPage
      })
      await this.getMainDataFromStore()
    },
    async onSortChange(param) {
      if ( param.length > 0 ) {
        const {
          field,
          type
        } = param[0]
        const selectedColumn = this.columns.findIndex(e => e.field === field)
        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getMainDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if ( Object.hasOwn(columnFilters, 'status') ) this.updateParams({ status: columnFilters.status })
      await this.getMainDataFromStore()
    },
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    async onSucceed() {
      await this.getMainDataFromStore()
    },
    async onSearchMainData() {
      await this.getMainDataFromStore()
    },
    async onApproveSuspend() {
      if ( this.filter.admissionRoundId === null ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Vui lòng chọn Đợt xét tuyển!',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return null
      }
      this.isLoading = true
      try {
        const request = {
          organizationId: this.filter.organizationId,
          admissionRoundId: this.filter.admissionRoundId,
        }
        const response = await this.createData(request)
        if ( response ) {
          const {
            isSuccessful,
            message
          } = response
          if ( isSuccessful ) {
            await this.getMainDataFromStore()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: message,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          }
        }
      } catch ( e ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
      return null
    },
  },
}
</script>
